// extracted by mini-css-extract-plugin
module.exports = {"vote-tools":"styles_vote-tools__5Ykre"};